import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#unless this.isHidden}}
  <PluginOutlet
    @name="category-list-above-each-category"
    @outletArgs={{hash category=this.category}}
  />

  <tr
    data-category-id={{this.category.id}}
    data-notification-level={{this.category.notificationLevelString}}
    class="{{if
        this.category.description_excerpt
        'has-description'
        'no-description'
      }}
      {{if this.category.uploaded_logo.url 'has-logo' 'no-logo'}}"
  >
    <td
      class="category {{if this.isMuted 'muted'}}"
      style={{category-color-variable this.category.color}}
    >
      <CategoryTitleLink @category={{this.category}} />
      <PluginOutlet
        @name="below-category-title-link"
        @connectorTagName="div"
        @outletArgs={{hash category=this.category}}
      />

      {{#if this.category.description_excerpt}}
        <div class="category-description">
          {{dir-span this.category.description_excerpt htmlSafe="true"}}
        </div>
      {{/if}}

      {{#if this.category.isGrandParent}}
        <table class="category-list subcategories-with-subcategories">
          <tbody>
            {{#each this.category.subcategories as |subcategory|}}
              <SubCategoryRow
                @category={{subcategory}}
                @listType={{this.listType}}
              />
            {{/each}}
            {{#if (gt this.category.unloadedSubcategoryCount 0)}}
              {{i18n
                "category_row.subcategory_count"
                count=this.category.unloadedSubcategoryCount
              }}
            {{/if}}
          </tbody>
        </table>
      {{else if this.category.subcategories}}
        <div class="subcategories">
          {{#each this.category.subcategories as |subcategory|}}
            <SubCategoryItem
              @category={{subcategory}}
              @listType={{this.listType}}
            />
          {{/each}}
          {{#if (gt this.category.unloadedSubcategoryCount 0)}}
            <div class="subcategories__more-subcategories">
              <LinkTo @route="discovery.subcategories" @model={{this.slugPath}}>
                {{i18n
                  "category_row.subcategory_count"
                  count=this.category.unloadedSubcategoryCount
                }}
              </LinkTo>
            </div>
          {{/if}}
        </div>
      {{/if}}
    </td>

    <td class="topics">
      <div title={{this.category.statTitle}}>{{html-safe
          this.category.stat
        }}</div>
      <CategoryUnread
        @category={{this.category}}
        @tagName="div"
        @unreadTopicsCount={{this.unreadTopicsCount}}
        @newTopicsCount={{this.newTopicsCount}}
        class="unread-new"
      />
    </td>

    {{#unless this.isMuted}}
      {{#if this.showTopics}}
        <td class="latest">
          {{#each this.category.featuredTopics as |t|}}
            {{#if this.currentUser.use_glimmer_topic_list}}
              <TopicList::FeaturedTopic @topic={{t}} />
            {{else}}
              <FeaturedTopic @topic={{t}} />
            {{/if}}
          {{/each}}
        </td>
      {{/if}}
    {{/unless}}
  </tr>
{{/unless}}
*/
{
  "id": "9Sye2PdF",
  "block": "[[[41,[51,[30,0,[\"isHidden\"]]],[[[1,\"  \"],[8,[39,1],null,[[\"@name\",\"@outletArgs\"],[\"category-list-above-each-category\",[28,[37,2],null,[[\"category\"],[[30,0,[\"category\"]]]]]]],null],[1,\"\\n\\n  \"],[10,\"tr\"],[15,\"data-category-id\",[30,0,[\"category\",\"id\"]]],[15,\"data-notification-level\",[30,0,[\"category\",\"notificationLevelString\"]]],[15,0,[29,[[52,[30,0,[\"category\",\"description_excerpt\"]],\"has-description\",\"no-description\"],\"\\n      \",[52,[30,0,[\"category\",\"uploaded_logo\",\"url\"]],\"has-logo\",\"no-logo\"]]]],[12],[1,\"\\n    \"],[10,\"td\"],[15,0,[29,[\"category \",[52,[30,0,[\"isMuted\"]],\"muted\"]]]],[15,5,[28,[37,4],[[30,0,[\"category\",\"color\"]]],null]],[12],[1,\"\\n      \"],[8,[39,5],null,[[\"@category\"],[[30,0,[\"category\"]]]],null],[1,\"\\n      \"],[8,[39,1],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"below-category-title-link\",\"div\",[28,[37,2],null,[[\"category\"],[[30,0,[\"category\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"category\",\"description_excerpt\"]],[[[1,\"        \"],[10,0],[14,0,\"category-description\"],[12],[1,\"\\n          \"],[1,[28,[35,6],[[30,0,[\"category\",\"description_excerpt\"]]],[[\"htmlSafe\"],[\"true\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"category\",\"isGrandParent\"]],[[[1,\"        \"],[10,\"table\"],[14,0,\"category-list subcategories-with-subcategories\"],[12],[1,\"\\n          \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"category\",\"subcategories\"]]],null]],null],null,[[[1,\"              \"],[8,[39,9],null,[[\"@category\",\"@listType\"],[[30,1],[30,0,[\"listType\"]]]],null],[1,\"\\n\"]],[1]],null],[41,[28,[37,10],[[30,0,[\"category\",\"unloadedSubcategoryCount\"]],0],null],[[[1,\"              \"],[1,[28,[35,11],[\"category_row.subcategory_count\"],[[\"count\"],[[30,0,[\"category\",\"unloadedSubcategoryCount\"]]]]]],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"category\",\"subcategories\"]],[[[1,\"        \"],[10,0],[14,0,\"subcategories\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"category\",\"subcategories\"]]],null]],null],null,[[[1,\"            \"],[8,[39,12],null,[[\"@category\",\"@listType\"],[[30,2],[30,0,[\"listType\"]]]],null],[1,\"\\n\"]],[2]],null],[41,[28,[37,10],[[30,0,[\"category\",\"unloadedSubcategoryCount\"]],0],null],[[[1,\"            \"],[10,0],[14,0,\"subcategories__more-subcategories\"],[12],[1,\"\\n              \"],[8,[39,13],null,[[\"@route\",\"@model\"],[\"discovery.subcategories\",[30,0,[\"slugPath\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,11],[\"category_row.subcategory_count\"],[[\"count\"],[[30,0,[\"category\",\"unloadedSubcategoryCount\"]]]]]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"]],[]],null]],[]]],[1,\"    \"],[13],[1,\"\\n\\n    \"],[10,\"td\"],[14,0,\"topics\"],[12],[1,\"\\n      \"],[10,0],[15,\"title\",[30,0,[\"category\",\"statTitle\"]]],[12],[1,[28,[35,14],[[30,0,[\"category\",\"stat\"]]],null]],[13],[1,\"\\n      \"],[8,[39,15],[[24,0,\"unread-new\"]],[[\"@category\",\"@tagName\",\"@unreadTopicsCount\",\"@newTopicsCount\"],[[30,0,[\"category\"]],\"div\",[30,0,[\"unreadTopicsCount\"]],[30,0,[\"newTopicsCount\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"isMuted\"]]],[[[41,[30,0,[\"showTopics\"]],[[[1,\"        \"],[10,\"td\"],[14,0,\"latest\"],[12],[1,\"\\n\"],[42,[28,[37,8],[[28,[37,8],[[30,0,[\"category\",\"featuredTopics\"]]],null]],null],null,[[[41,[30,0,[\"currentUser\",\"use_glimmer_topic_list\"]],[[[1,\"              \"],[8,[39,16],null,[[\"@topic\"],[[30,3]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,17],null,[[\"@topic\"],[[30,3]]],null],[1,\"\\n\"]],[]]]],[3]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"subcategory\",\"subcategory\",\"t\"],false,[\"unless\",\"plugin-outlet\",\"hash\",\"if\",\"category-color-variable\",\"category-title-link\",\"dir-span\",\"each\",\"-track-array\",\"sub-category-row\",\"gt\",\"i18n\",\"sub-category-item\",\"link-to\",\"html-safe\",\"category-unread\",\"topic-list/featured-topic\",\"featured-topic\"]]",
  "moduleName": "discourse/components/parent-category-row.hbs",
  "isStrictMode": false
});